/* Acre header: desktop mega menu panels and mobile drawer sub-menus. */
(() => {
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 220;
  let mega = null;

  class MegaNav {
    constructor(header) {
      this.wrapper = document.getElementById('HeaderWrapper');
      this.triggers = Array.from(header.querySelectorAll('[data-acre-trigger]'));
      this.current = null;
      this.timer = null;
      this.pointer = 'mouse';
      this.triggers.forEach((trigger) => this.bind(trigger));
      const scrim = header.querySelector('[data-acre-scrim]');
      if (scrim) scrim.addEventListener('click', () => this.close());
    }

    panelFor(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    bind(trigger) {
      const item = trigger.closest('.acre-nav__item');
      const isButton = trigger.tagName === 'BUTTON';

      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.schedule(() => this.open(trigger), this.current ? 0 : OPEN_DELAY);
      });
      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.schedule(() => this.close(), CLOSE_DELAY);
      });

      // Touch: the first tap opens the panel, a second tap follows the link.
      // A name without a link (a button, "Link the menu item name" off): a mouse click opens its panel,
      // and a tap, Enter or Space opens or closes it.
      trigger.addEventListener('pointerdown', (event) => {
        this.pointer = event.pointerType;
      });
      trigger.addEventListener('click', (event) => {
        if (isButton) {
          const toggle = this.pointer !== 'mouse' || event.detail === 0;
          if (toggle && this.current === trigger) this.close();
          else this.open(trigger);
        } else if (this.pointer !== 'mouse' && this.current !== trigger) {
          event.preventDefault();
          this.open(trigger);
        }
        this.pointer = 'mouse';
      });

      // ArrowDown, or Space on a link, opens the panel and moves to its first link.
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && (event.key !== ' ' || isButton)) return;
        event.preventDefault();
        this.open(trigger);
        const first = this.panelFor(trigger).querySelector('a[href], button');
        if (first) first.focus();
      });

      item.addEventListener('focusout', (event) => {
        if (this.current === trigger && !item.contains(event.relatedTarget)) this.close();
      });
    }

    schedule(fn, delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(fn, delay);
    }

    open(trigger) {
      clearTimeout(this.timer);
      if (this.current === trigger) return;
      if (this.current) this.hide(this.current);
      this.current = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      this.panelFor(trigger).classList.add('is-open');
      if (this.wrapper) this.wrapper.classList.add('acre-open');
    }

    hide(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      this.panelFor(trigger).classList.remove('is-open');
    }

    close() {
      clearTimeout(this.timer);
      if (!this.current) return;
      this.hide(this.current);
      this.current = null;
      if (this.wrapper) this.wrapper.classList.remove('acre-open');
    }

    openPanel(panel) {
      const trigger = this.triggers.find((t) => t.getAttribute('aria-controls') === panel.id);
      if (trigger) this.open(trigger);
    }
  }

  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.acreReady) return;
    drawer.dataset.acreReady = 'true';
    const root = drawer.querySelector('[data-acre-root]');
    const subs = Array.from(drawer.querySelectorAll('[data-acre-sub]'));

    const show = (id) => {
      subs.forEach((sub) => {
        const active = sub.dataset.acreSub === id;
        sub.classList.toggle('is-active', active);
        sub.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) sub.scrollTop = 0;
      });
      if (root) {
        root.classList.toggle('is-behind', Boolean(id));
        root.setAttribute('aria-hidden', id ? 'true' : 'false');
      }
    };

    drawer.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-acre-open]');
      if (opener) {
        event.preventDefault();
        show(opener.dataset.acreOpen);
        const sub = subs.find((s) => s.dataset.acreSub === opener.dataset.acreOpen);
        const back = sub && sub.querySelector('[data-acre-back]');
        if (back) setTimeout(() => back.focus({ preventScroll: true }), 60);
        return;
      }
      const back = event.target.closest('[data-acre-back]');
      if (back) {
        event.preventDefault();
        const id = back.closest('[data-acre-sub]').dataset.acreSub;
        show(null);
        const returnTo = drawer.querySelector('[data-acre-open="' + id + '"]');
        if (returnTo) setTimeout(() => returnTo.focus({ preventScroll: true }), 60);
      }
    });

    document.addEventListener('drawerOpen.NavDrawer', () => show(null));
  }

  function init() {
    const header = document.querySelector('.acre-header');
    if (header && !header.dataset.acreReady) {
      header.dataset.acreReady = 'true';
      mega = new MegaNav(header);
    }
    initDrawer(document.getElementById('NavDrawer'));
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !mega || !mega.current) return;
    const trigger = mega.current;
    mega.close();
    trigger.focus();
  });
  document.addEventListener('predictive-search:open', () => {
    if (mega) mega.close();
  });

  // Theme editor: show a panel while its block (or one of its service cards) is selected.
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest && event.target.closest('[data-acre-panel]');
    if (panel && mega) mega.openPanel(panel);
  });
  document.addEventListener('shopify:block:deselect', () => {
    if (mega) mega.close();
  });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
